// action
import {
    SAVE_CONTAINER,
    SAVE_CONTAINER_FAIL,
    SAVE_CONTAINER_SUCCESS,
    SAVE_CONTAINER_RESET
} from '../action/saveContainerAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SAVE_CONTAINER:
            return {
                ...state,
                apiState: "loading"
            }
        case SAVE_CONTAINER_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case SAVE_CONTAINER_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case SAVE_CONTAINER_RESET:
            return initialState
        default:
            return state
    }
}